"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import classNames from "classnames";
import styles from "./SectionContainer.module.css";
export const SectionContainer = (props) => {
  const { children, headerTitle, theme, abilityToClose = false, sectionTitleWithBtn, readOnlyTheme = false, onHide } = props;
  const [collapseSection, setCollapseSection] = useState(false);
  const closeSectionContainer = useCallback(() => {
    if (!abilityToClose) return;
    onHide == null ? void 0 : onHide(collapseSection);
    setCollapseSection(!collapseSection);
  }, [abilityToClose, collapseSection]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames(styles.sectionContainerRoot, theme, "container-class", {
        [styles.sectionContainerWrapperClose]: collapseSection
      }),
      children: [
        /* @__PURE__ */ jsx("div", { className: classNames(styles.wrapper, { [styles.readOnly]: readOnlyTheme }), children: /* @__PURE__ */ jsx(
          SectionHeader,
          {
            onClick: closeSectionContainer,
            collapseSection,
            headerTitle,
            abilityToClose,
            sectionTitleWithBtn
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: classNames("section-container-content", styles.containerContent, { [styles.close]: collapseSection }), children })
      ]
    }
  );
};
export const SectionHeader = (props) => {
  const { collapseSection = false, onClick, headerTitle, abilityToClose = false, sectionTitleWithBtn = false } = props;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames("section-container-header", styles.sectionHeaderRoot, {
        [styles.allowClose]: abilityToClose,
        [styles.noAllowClose]: !abilityToClose,
        [styles.hasButton]: sectionTitleWithBtn
      }),
      onClick,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      },
      role: "button",
      tabIndex: 0,
      "aria-expanded": !collapseSection,
      children: [
        headerTitle,
        abilityToClose && /* @__PURE__ */ jsxs("div", { className: styles.closeButton, children: [
          /* @__PURE__ */ jsx("span", { className: styles.arrow }),
          collapseSection ? "Show" : "Hide"
        ] })
      ]
    }
  );
};
